import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import { Check } from 'lucide-react';

const AbaCarrinho = () => {
  const [selectedOption, setSelectedOption] = useState('change-plan');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [cpf, setCpf] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Formulário enviado com sucesso!');
  };

  return (
    <div className="form-section">
      <h2 className="form-title">Veja como é fácil. Conta pra gente o que deseja fazer:</h2>
      <Card>
        <div className='card-options'>
          <div className="radio-options">
            <label className="radio-option">
              <input type="radio" value="change-plan" checked={selectedOption === 'change-plan'} onChange={(e) => setSelectedOption(e.target.value)} />
              <span className="radio-label">Mudar meu plano da Giga</span>
            </label>
            <label className="radio-option">
              <input type="radio" value="bring-number" checked={selectedOption === 'bring-number'} onChange={(e) => setSelectedOption(e.target.value)} />
              <span className="radio-label">Trazer meu número para Giga</span>
            </label>
            <label className="radio-option">
              <input type="radio" value="new-line" checked={selectedOption === 'new-line'} onChange={(e) => setSelectedOption(e.target.value)} />
              <span className="radio-label">Quero uma linha nova da Giga</span>
            </label>
          </div>

          <p className="form-instruction">Insira seu número atual, e-mail e CPF:</p>

          <div className="form-fields">
            <div className="input-group">
              <input type="tel" placeholder="Telefone com DDD" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} className="form-input" />
              <input type="email" placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} className="form-input" />
              <input type="text" placeholder="CPF" value={cpf} onChange={(e) => setCpf(e.target.value)} className="form-input" />
            </div>
            <button onClick={handleSubmit} className="submit-button">Eu quero!</button>
          </div>
        </div>
      </Card>

      {/* Resumo da compra (você pode extrair para componente também) */}
      {/* <div className="summary-section">
        <h3 className="summary-title">Resumo da compra</h3>
        <div className="price-section">
          <div className="price-label"><span>Valor Total</span></div>
          <div className="price-value">R$ 59,90 <span className="price-period">/mês</span></div>
          <div className="price-details">Boleto<br />Fidelizado por 12 meses</div>
        </div>
        <div className="plan-details">
          <div className="plan-brand"><span className="Giga-brand">Giga </span><span className="plan-type">controle</span></div>
          <div className="plan-data">30GB</div>
          <div className="plan-features">
            <div className="feature">15GB Livres</div>
            <div className="feature">10GB de Bônus</div>
            <div className="feature">5GB de redes sociais</div>
            <div className="feature unlimited">LIGAÇÕES ILIMITADAS</div>
            <div className="feature">para qualquer lugar do Brasil</div>
          </div>
        </div>
        <div className="whatsapp-section">
          <div className="whatsapp-title">WhatsApp ilimitado:</div>
          <div className="whatsapp-icon"><Check size={16} /></div>
          <div className="whatsapp-description">Para redes sociais e vídeos</div>
        </div>
        <div className="social-icons">
          <div className="social-icon instagram">ig</div>
          <div className="social-icon facebook">f</div>
          <div className="social-icon tiktok">tt</div>
          <div className="social-icon twitter">x</div>
          <div className="social-icon youtube">yt</div>
        </div>
      </div> */}
    </div>
  );
};

export default AbaCarrinho;
